<!-- <div class="select-wrapper">
    <text theme="label" *ngIf="label" [required]="required">{{ label }}</text>

    <select
        class="select"
        [ngClass]="[theme]"
        (ngModelChange)="onSelectionChangeHandler($event)"
        [ngModel]="value"
    >
        <option [ngValue]="undefined" [disabled]="true">
            {{ placeholder }}
        </option>
        <option class="option" *ngFor="let opt of options" [ngValue]="opt">
            {{ opt.text }}
        </option>
    </select>
</div> -->

<div class="select-wrapper">
    <text theme="label" *ngIf="label" [required]="required">{{ label }}</text>

    <div class="select" [ngClass]="[theme]" (click)="toggleDropdown()">
        <div
            class="selected-option"
            [class.placeholder-color]="
                !value || selectedOptionText === placeholder
            "
        >
            {{ selectedOptionText }}
        </div>
        <img
            class="arrow-icon"
            [src]="'./assets/img/svg/account/arrow.svg'"
            alt="Arrow Icon"
            [class.open]="isDropdownOpen"
        />
        <div class="dropdown" *ngIf="isDropdownOpen">
            <div
                class="option"
                *ngFor="let opt of options"
                (click)="selectOption(opt); $event.stopPropagation()"
            >
                {{ opt.text }}
            </div>
        </div>
    </div>
</div>
